<template>
  <Teleport to="body">
    <div class="modal fixed z-30 w-full dark:text-white">
      <div
        class="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-90"
      />
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="w-full flex h-full items-start justify-center p-4 text-center sm:items-start sm:p-0"
        >
          <transition
            enter-active-class="transform ease-out duration-150 transition delay-150 opacity-0 scale-75"
            enter-to-class="opacity-90 scale-110"
            appear
          >
            <div
              class="relative text-left transition-all transform rounded-lg shadow-xl w-full my-auto"
              :class="{
                'sm:max-w-md': !large,
                'sm:max-w-2xl': large & !medium,
                'sm:max-w-lg': medium & !large,
                'py-6 px-7': !noPadding,
                'bg-block-3 border-2 border-gray-2 rounded-3xl':
                  !blank,
              }"
            >
              <div
                class="relative flex items-center justify-start md:justify-center w-full mb-2"
              >
                <h1
                  v-if="title"
                  class="font-bold text-2xl w-full text-white"
                  :class="{
                    'pt-5 pb-2': noPadding,
                    'text-center': titleCenter,
                    'text-left': !titleCenter,
                  }"
                >
                  {{ title }}
                </h1>
                <button
                  v-if="withClose"
                  class="absolute inset-y-0 right-0"
                  @click="$emit('close')"
                  :class="{
                    '-top-5': blank,
                    'top-3 right-3': noPadding,
                    'pointer-events-none': isLoading
                  }"
                >
                  <IconClose />
                </button>
              </div>
              <div
                class="flex flex-col"
                :class="{
                  'pb-3': !noPadding,
                }"
              >
                <h3
                  v-if="subText"
                  class="mt-3 text-md md:text-center sm:mt-2 text-gray-600"
                >
                  {{ subText }}
                </h3>
                <div
                  :class="{
                    'mt-4': !noPadding,
                  }"
                >
                  <slot />
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import IconClose from "../icons/IconClose.vue";
export default {
  name: "Modal",
  components: {
    IconClose,
  },
  props: {
    title: {
      type: String,
    },
    subText: {
      type: String,
    },
    large: {
      type: Boolean,
    },
    medium: {
      type: Boolean,
    },
    noPadding: {
      type: Boolean,
    },
    blank: {
      type: Boolean,
    },
    withClose: {
      type: Boolean,
      default: true,
    },
    titleCenter: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  emits: ["close"],
};
</script>
